__turbopack_context__.v({
  "verticalSeparator": "VerticalSeparator-module__FvIqCq__verticalSeparator",
  "verticalSeparatorAccent": "VerticalSeparator-module__FvIqCq__verticalSeparatorAccent",
  "verticalSeparatorInverted": "VerticalSeparator-module__FvIqCq__verticalSeparatorInverted",
  "verticalSeparatorLight": "VerticalSeparator-module__FvIqCq__verticalSeparatorLight",
  "verticalSeparatorRegular": "VerticalSeparator-module__FvIqCq__verticalSeparatorRegular",
});
